// extracted by mini-css-extract-plugin
module.exports = {"form":"ModalSign_form__1yRwy","signatureButtonsRight":"ModalSign_signatureButtonsRight__2KyYG"};